/**
 * Dummy data — 문의 (Inquiries)
 * API_DOCS: endpoints.inquiries / endpoints.admin.inquiries
 *
 * InquiryResponse:
 *   id(int), user_id(int?), user_name(string), title(string),
 *   content(string), answer(string?), status(string="pending"|"answered"),
 *   created_at(datetime)
 */

const inquiries = [
  { id: 1, user_id: 1, user_name: '홍길동', title: '공항 이동 예약 변경 문의', content: '예약 날짜를 변경하고 싶습니다.', answer: '예약 변경은 마이페이지에서 가능합니다.', status: 'answered', created_at: '2026-02-10T09:00:00' },
  { id: 2, user_id: 2, user_name: '김철수', title: '결제 오류 문의', content: '결제가 두 번 된 것 같습니다.', answer: null, status: 'pending', created_at: '2026-02-15T14:30:00' },
  { id: 3, user_id: 3, user_name: '이영희', title: '반려동물 이동 추가 요금 문의', content: '대형견도 이용 가능한가요?', answer: '대형견 이용 가능합니다. 추가 요금은 없습니다.', status: 'answered', created_at: '2026-02-20T11:00:00' },
  { id: 4, user_id: null, user_name: '비회원', title: '비회원 예약 확인 문의', content: '예약번호로 조회가 안 됩니다.', answer: null, status: 'pending', created_at: '2026-03-01T16:00:00' },
];

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/* ── 서비스 (유저용) ── */

/** POST /api/inquiries */
export const createInquiry = async (data) => {
  await delay(400);
  const inquiry = {
    id: inquiries.length + 1,
    user_id: data.user_id || null,
    user_name: data.user_name || '비회원',
    title: data.title,
    content: data.content,
    answer: null,
    status: 'pending',
    created_at: new Date().toISOString(),
  };
  inquiries.push(inquiry);
  return { message: '문의가 등록되었습니다' };
};

/** GET /api/inquiries — 본인 문의 목록 (dummy: 로그인 user_id=1 가정) */
export const getMyInquiries = async () => {
  await delay(200);
  const myUserId = 1;
  return inquiries.filter((q) => q.user_id === myUserId);
};

/** GET /api/inquiries/:id — 본인 문의 상세 */
export const getMyInquiryById = async (id) => {
  await delay(200);
  const found = inquiries.find((q) => q.id === Number(id));
  if (!found) throw new Error('문의를 찾을 수 없습니다');
  return found;
};

/* ── 관리자 ── */

/** GET /api/admin/inquiries */
export const getAdminInquiries = async (params = {}) => {
  await delay(300);
  const page = params.page || 1;
  const size = params.size || 20;
  let filtered = [...inquiries];
  if (params.status) filtered = filtered.filter((q) => q.status === params.status);
  const total = filtered.length;
  const start = (page - 1) * size;
  return {
    items: filtered.slice(start, start + size),
    total,
    page,
    size,
    pages: Math.ceil(total / size),
  };
};

/** GET /api/admin/inquiries/:id */
export const getAdminInquiryById = async (id) => {
  await delay(200);
  const found = inquiries.find((q) => q.id === Number(id));
  if (!found) throw new Error('문의를 찾을 수 없습니다');
  return found;
};

/** PUT /api/admin/inquiries/:id — 답변 등록 */
export const answerAdminInquiry = async (id, data) => {
  await delay(400);
  const idx = inquiries.findIndex((q) => q.id === Number(id));
  if (idx === -1) throw new Error('문의를 찾을 수 없습니다');
  inquiries[idx].answer = data.answer;
  inquiries[idx].status = 'answered';
  return inquiries[idx];
};
